import React, { useEffect, useRef } from "react";
import "./ToolConfirmModal.css";

// In-app replacement for window.confirm on tool pages, so a live-run warning
// can carry the run's details instead of a single blob of text. Styling comes
// from ToolPage.css so it reads as part of the tool page, not a separate modal
// system.
function ToolConfirmModal({
  open,
  title,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  onConfirm,
  onCancel,
  children,
}) {
  const cancelRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (event) => {
      if (event.key === "Escape") onCancel();
    };
    document.addEventListener("keydown", onKeyDown);
    document.body.style.overflow = "hidden";
    // Focus Cancel, not Confirm — a stray Enter should not start a live run.
    cancelRef.current?.focus();
    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = "";
    };
  }, [open, onCancel]);

  if (!open) return null;

  return (
    <div className="tool-confirm-overlay" onClick={onCancel}>
      <div
        className="tool-confirm-card"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="tool-confirm-title"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="tool-confirm-header">
          <h3 className="tool-page-title" id="tool-confirm-title">
            {title}
          </h3>
        </div>
        <div className="tool-confirm-body">{children}</div>
        <div className="tool-confirm-actions">
          <button
            type="button"
            className="tool-btn-secondary"
            onClick={onCancel}
            ref={cancelRef}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className="tool-btn-primary"
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ToolConfirmModal;
